import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';
import StructureContainers from '@Services/StructureContainers';
import AppStorage from '@Services/AppStorage';
import { clearSearchInStore } from '@Containers/QuickSearchAutosuggest';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import NotifyDialogsService from '@Containers/Dialogs/NotifyDialogsService';
import { QUICK_SEARCH_STRUCTURE_UID, QUICK_SEARCH_TEXTS, QUICK_SEARCH_CACHE_NAME } from './QuickSearchConstants';

export function getLabels() {
  return MessageBroker.send(RequestUrls.searchLabels).catch(Logger.reject);
}

export function showSynthesisPannerInfoDialog() {
  return NotifyDialogsService.openModalWindow({
    title: QUICK_SEARCH_TEXTS.synthesisPlannerInfoDialogTitle,
    text: QUICK_SEARCH_TEXTS.synthesisPlannerInfoDialogText,
    confirmText: QUICK_SEARCH_TEXTS.synthesisPlannerInfoDialogButton,
    type: 'info',
    backdrop: 'static',
  });
}

export function clearCache() {
  AppStorage.instance.remove(QUICK_SEARCH_CACHE_NAME);
  StructureContainers.removeContainerByUID(QUICK_SEARCH_STRUCTURE_UID);
}

/**
 * @name handleAction
 * @param {String} action shows what should be done with cache (possible values: 'new' | 'edit' | 'synthesis' | nothing)
 * @description if passed nothing: redirect to results preview if `searchId` available in cache, uses cache otherwise
 * if 'synthesis'  passed: cleans all saved data, shows synthesis planner's message
 * if 'new'  passed: cleans all saved data
 * if 'edit' passed: removes `searchId` from cache and uses it
 */
export async function initializeQuickSearch(action) {
  const cache = AppStorage.instance.get(QUICK_SEARCH_CACHE_NAME);
  if (action === 'synthesis') {
    clearCache();
    showSynthesisPannerInfoDialog();
  } else if (action === 'new') {
    clearCache();
    clearSearchInStore(); // React
  } else if (cache && cache.searchId && (action === 'preview' || history.location.pathname === paths.PREVIEW)) {
    if (history.location.pathname === paths.PREVIEW) {
      return history.replace({
        pathname: paths.PREVIEW,
        state: { searchId: cache.searchId },
      });
    }
    return history.push({
      pathname: paths.PREVIEW,
      state: { searchId: cache.searchId },
    });
  }
  return history.push(paths.SEARCH);
}
